import { useEffect, useState } from 'react'
import { getAdminToken } from '../api'
import { validateSession } from './sessionAuth'

/** 校验 JWT 登录态（不自动填账号密码登录）。 */
export function useAdminAuth() {
  const [ready, setReady] = useState(false)
  const [loggedIn, setLoggedIn] = useState(() => !!getAdminToken())

  useEffect(() => {
    const sync = () => {
      setLoggedIn(!!getAdminToken())
    }
    window.addEventListener('admin-session-sync', sync)
    window.addEventListener('focus', sync)

    void validateSession().then((ok) => {
      setLoggedIn(ok)
      setReady(true)
    })

    return () => {
      window.removeEventListener('admin-session-sync', sync)
      window.removeEventListener('focus', sync)
    }
  }, [])

  return { ready, loggedIn }
}
